export default "__VITE_ASSET__CVqm$B5D__"